var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailexternallink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#EFF3F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3676 5.99619C10.7111 5.99619 10.9921 6.27719 11 6.6207V9.13448C11 10.1649 10.1646 11.0001 9.13423 11.0001H2.86552C1.83514 11.0001 1 10.165 1 9.13435V2.86577C0.999875 1.83539 1.83501 1 2.86552 1H5.37143C5.53692 1.00046 5.6955 1.06641 5.81251 1.18342C5.92953 1.30044 5.99548 1.45902 5.99594 1.62451C5.99548 1.79 5.92953 1.94857 5.81251 2.06559C5.6955 2.18261 5.53692 2.24855 5.37143 2.24902H2.86552C2.52214 2.24902 2.24889 2.53014 2.24889 2.86577V9.1266C2.24889 9.47011 2.52989 9.74336 2.86552 9.74336H9.12635C9.46986 9.74336 9.74311 9.46223 9.74311 9.1266V6.6207C9.74357 6.45521 9.80952 6.29663 9.92653 6.17961C10.0436 6.06259 10.2021 5.99665 10.3676 5.99619ZM10.3676 1C10.7111 1 10.9921 1.281 11 1.62451V4.12266C10.9995 4.28817 10.9336 4.44677 10.8165 4.56379C10.6995 4.68081 10.5409 4.74674 10.3754 4.74717C10.2099 4.74671 10.0513 4.68077 9.93428 4.56375C9.81727 4.44673 9.75132 4.28815 9.75086 4.12266V3.13115L5.51206 7.37008C5.38705 7.48721 5.23093 7.54971 5.06705 7.54971C4.90305 7.54971 4.74705 7.49508 4.62205 7.37008C4.38004 7.12808 4.38004 6.73007 4.62205 6.48794L8.86085 2.24914H7.86959C7.70408 2.24868 7.54548 2.18272 7.42846 2.06567C7.31144 1.94863 7.24551 1.79002 7.24508 1.62451C7.24554 1.45902 7.31148 1.30044 7.4285 1.18342C7.54552 1.06641 7.7041 1.00046 7.86959 1H10.3676Z",
    fill: "#5D88F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailexternallink);
export default __webpack_public_path__ + "static/media/detailexternallink.dd9fe4ee8dcffc840e221c83a50e4116.svg";
export { ForwardRef as ReactComponent };